import React, { useEffect, useRef, useState } from "react";
import ActionsBar from "components/SubHeader/ActionsBar";
import SubHeader from "components/SubHeader";
import SubHeaderTitle from "components/SubHeader/SubHeaderTitle";
import { useTranslation } from "react-i18next";
import { netCall } from "utils/netCall";
import { UserManagementApiUrl } from "environment/routeSettings";
import { TProvince, TUser } from "types/dto";
import { toast } from "react-toastify";
import { useURLTools } from "utils/URLtools";
import { DataGridRef } from "devextreme-react/data-grid";
import { AddUseModal, TAddFormTypes } from "./AddUserModal";
import { TUsersGridRow } from "components/Grid/grids/UsersGrid/types";
import UsersGrid from "components/Grid/grids/UsersGrid";
import { TResponseCode } from "utils/netCall/types";

const UsersView = () => {
  const { t } = useTranslation();
  const { navigateWithQueryParams } = useURLTools();

  const [users, setUsers] = useState<TUser[]>([]);
  const [isUsersLoading, setIsUsersLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const GridRef = useRef<DataGridRef<any, any>>(null);

  const onAddClick = () => {
    setAddModalOpen(true);
  };

  const onSubmitAddUser = async (values: TAddFormTypes) => {
    setIsSubmitting(true);
    const res = await netCall<TProvince>({
      method: "POST",
      endPoint: `${UserManagementApiUrl()}/api/SamaUser/RegisterUser`,
      body: {
        ...values,
      },
    });
    if (res.responseCode === TResponseCode.OK) {
      setIsSubmitting(false);
      toast.success(t("operationSuccessful"));
      setAddModalOpen(false);
      getUsers();
      // GridRef.current?.instance().refresh();
    } else {
      setIsSubmitting(false);
      toast.error(t("operationFailed"));
    }
  };

  const onUserRowClick = (row: TUsersGridRow) => {
    navigateWithQueryParams(`/dashboard/users/details/${row.id}`, [], {
      replace: true,
    });
  };

  const getUsers = async () => {
    setIsUsersLoading(true);
    const res = await netCall<TUser[]>({
      method: "GET",
      endPoint: `${UserManagementApiUrl()}/api/SamaUser/GetUsers`,
    });
    if (res.responseCode === TResponseCode.OK) {
      const records = res.results;
      setUsers(records);
    }
    setIsUsersLoading(false);
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      <SubHeader>
        <SubHeaderTitle>{t("users")}</SubHeaderTitle>
        <ActionsBar
          requestTime={0}
          isLoading={false}
          actionButtons={[
            {
              iconName: "MdAdd",
              buttonTooltip: t("add"),
              action: onAddClick,
              permissions: ["superadmin", "d_user"],
            },
          ]}
        />
      </SubHeader>
      <div className={"w-full flex gap-x h-[calc(100%-56px)]"}>
        <UsersGrid
          enableDetailsContextMenu
          data={users}
          isLoading={isUsersLoading}
          ref={GridRef}
          onRowClick={onUserRowClick}
        />
      </div>
      {addModalOpen && (
        <AddUseModal
          onClose={() => setAddModalOpen(false)}
          isOpen={addModalOpen}
          onSubmit={onSubmitAddUser}
          isLoading={isSubmitting}
        />
      )}
    </>
  );
};

export default UsersView;
